module.exports = __webpack_public_path__ + "img/zuhou_8.0af72d42.png";